import create from 'zustand'
import { devtools } from 'zustand/middleware'
import immer from "./immer"

let useBranchStore = (set) => ({
    branches: [],
    loading: true,
    addBranch: (branch) => set((state) => void (state.branches.push(branch))),
    addAllBranches: (branches) => set((state) => {
        state.branches = branches;
        state.loading = false;
    }),
    currentBranch: { years: [] },
    updateEoas: (eoa) => set(state => void (state.currentBranch.eoa = eoa)),
    seCurrentBranch: (branch) => set((state) => {
        state.currentBranch = branch;
        state.branchId = branch._id;
    }),
    branchId: null,
    setBranchId: (id) => set(state => void (state.branchId = id)),
    degree: {},
    setDegree: (degree) => set((state) => void (state.degree = degree))
})
useBranchStore = devtools(useBranchStore, { name: "branches" });
useBranchStore = immer(useBranchStore);
export default create(useBranchStore);